import { render, staticRenderFns } from "./LogoutChallenge.vue?vue&type=template&id=67459da5&"
import script from "./LogoutChallenge.vue?vue&type=script&lang=js&"
export * from "./LogoutChallenge.vue?vue&type=script&lang=js&"
import style0 from "./LogoutChallenge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports